// TerminalView — live terminal output for the Run detail page's Terminal
// tab (FD §22.3), fed by the same RunEvent[] useSSE produces.
//
// TODO: this only renders `agent_message` text as plain lines. A real
// implementation needs: raw stdout/stderr line events (not yet a RunEvent
// variant — would extend @goblic/shared's RunEvent union), ANSI escape
// sequence rendering (e.g. via xterm.js or ansi-to-html), a "stick to
// bottom unless the user scrolled up" autoscroll heuristic, and a
// collapse/expand toggle for verbose tool output (FD §22.4: "De gebruiker
// kan bepalen of technische details, terminalregels en uitgebreide
// tooloutput worden ingeklapt of volledig getoond").

import { useEffect, useRef } from 'react'
import type { RunEvent } from '@goblic/shared'

export interface TerminalViewProps {
  events: RunEvent[]
}

export function TerminalView({ events }: TerminalViewProps) {
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    // TODO: only auto-scroll when the user hasn't manually scrolled up.
    const el = containerRef.current
    if (el) {
      el.scrollTop = el.scrollHeight
    }
  }, [events.length])

  const lines = events.filter(
    (event): event is Extract<RunEvent, { type: 'agent_message' }> =>
      event.type === 'agent_message'
  )

  return (
    <div
      ref={containerRef}
      className="h-[28rem] overflow-y-auto rounded-panel bg-term p-4 font-mono text-xs text-term-ink"
    >
      {lines.length === 0 ? (
        <p className="text-term-ink/50">
          No output yet. It streams in here while the agent works.
        </p>
      ) : (
        lines.map((event) => (
          <div
            className="whitespace-pre-wrap py-0.5 leading-relaxed"
            key={event.id}
          >
            {event.message}
          </div>
        ))
      )}
    </div>
  )
}
